import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadEvents } from "../../redux/actions/eventActions";
import EventList from "./EventList";
import "./Reoccurring.scss";

export default function EventListPage(): Element {
  const dispatch = useDispatch();
  const events = useSelector(state => state.events);
  const date = useSelector(state => state.date);
  const city = useSelector(state => state.selectedCity);
  const [todaysEvents, setTodaysEvents] = useState([]);

  useEffect(() => {
    if (events.length > 0 && events[0].id === 0) {
      dispatch(loadEvents(date, city)).catch(error => {
        console.log(error);
      });
    } else {
      setTodaysEvents(
        events.filter(
          event =>
            new Date(event.startdate).toDateString() ===
            new Date(date).toDateString()
        )
      );
    }
  }, [events, date]);

  return <EventList events={todaysEvents} />;
}
